import {
  B000190LogicalsokoNm,
  B000190PhysicalsokoNmr,
  catchRestError,
  RestClient,
} from "clients/rest";
import {
  B100100Sokoshubetsu,
  getSCode,
  LocationKanriKbn,
  SakujoyoteiKbn,
} from "messages/codes";
import { UseFormReturn } from "react-hook-form";
import { locationkanriKbn, sokoshubetsuKbn } from "services/codes";

// 固定値
const physicalsokoCd = "901";
const logicalsokoCd = "001";

export type B100100CreateRequest = {
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  locationkanriKbn: string;
  sakujoyoteiKbn: string;
} & Partial<{
  sokoKana: string;
  sokoNmr: string;
  logicalsokoCd: string;
  physicalsokoCd: string;
}>;

//新規登録処理
export const B100100Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100100CreateRequest = {
    sokoCd: fields.sokoCd,
    sokoNm: fields.sokoNm,
    sokoKana: fields.sokoKana,
    sokoNmr: fields.sokoNmr,
    sokoshubetsuKbn: fields.sokoshubetsuKbn?.value,
    logicalsokoCd: fields.logicalsokoCd,
    physicalsokoCd: fields.physicalsokoCd,
    locationkanriKbn: fields.locationkanriKbn?.value,
    sakujoyoteiKbn: fields.sakujoyoteiKbn?.value,
  };

  return RestClient.post("b100100/create", data);
};

export type B100100UpdateRequest = {
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  locationkanriKbn: string;
  sakujoyoteiKbn: string;
} & Partial<{
  sokoKana: string;
  sokoNmr: string;
  logicalsokoCd: string;
  physicalsokoCd: string;
  version: string;
}>;

//更新処理
export const B100100Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100100UpdateRequest = {
    sokoCd: fields.sokoCd,
    sokoNm: fields.sokoNm,
    sokoKana: fields.sokoKana,
    sokoNmr: fields.sokoNmr,
    sokoshubetsuKbn: fields.sokoshubetsuKbn?.value,
    logicalsokoCd: fields.logicalsokoCd,
    physicalsokoCd: fields.physicalsokoCd,
    locationkanriKbn: fields.locationkanriKbn?.value,
    sakujoyoteiKbn: fields.sakujoyoteiKbn?.value,
    version: fields.version,
  };

  return RestClient.put("b100100/update", data);
};

export type B100100GetRequest = {
  sokoCd: string;
};

export type B100100GetResponse = {
  sokoCd: string;
  sokoNm: string;
  sokoKana: string;
  sokoNmr: string;
  sokoshubetsuKbn: string;
  logicalsokoCd: string;
  logicalsokoNmr: string;
  physicalsokoCd: string;
  physicalsokoNmr: string;
  locationkanriKbn: string;
  sakujoyoteiKbn: string;
  version: number;
};

export const B100100Get = (props: B100100GetRequest) => {
  return RestClient.get<B100100GetResponse>("b100100/get", {
    params: props,
  });
};

// 倉庫情報表示処理
export const B100100Soko = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCd === "") {
    methods.setValue("sokoNm", "");
    methods.setValue("sokoKana", "");
    methods.setValue("sokoNmr", "");
    methods.setValue(
      "sokoshubetsuKbn",
      getSCode(B100100Sokoshubetsu, sokoshubetsuKbn.hikiateSoko)
    );
    methods.setValue("logicalsokoCd", "");
    methods.setValue("logicalsokoNmr", "");
    methods.setValue("physicalsokoCd", "");
    methods.setValue("physicalsokoNmr", "");
    methods.setValue(
      "locationkanriKbn",
      getSCode(LocationKanriKbn, locationkanriKbn.notManagement)
    );
    methods.setValue("sakujoyoteiKbn", getSCode(SakujoyoteiKbn, "0"));
    methods.setValue("version", "");
    return;
  }
  await B100100Get({ sokoCd: data.sokoCd })
    .then((response) => {
      methods.setValue("sokoNm", response.data.sokoNm ?? "");
      methods.setValue("sokoKana", response.data.sokoKana ?? "");
      methods.setValue("sokoNmr", response.data.sokoNmr ?? "");
      methods.setValue(
        "sokoshubetsuKbn",
        getSCode(B100100Sokoshubetsu, response.data.sokoshubetsuKbn ?? null)
      );
      methods.setValue("logicalsokoCd", response.data.logicalsokoCd ?? "");
      methods.setValue("logicalsokoNmr", response.data.logicalsokoNmr ?? "");
      methods.setValue("physicalsokoCd", response.data.physicalsokoCd ?? "");
      methods.setValue("physicalsokoNmr", response.data.physicalsokoNmr ?? "");
      methods.setValue(
        "locationkanriKbn",
        getSCode(LocationKanriKbn, response.data.locationkanriKbn ?? null)
      );
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn ?? null)
      );
      methods.setValue("version", response.data.version ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNm", "");
      methods.setValue("sokoKana", "");
      methods.setValue("sokoNmr", "");
      methods.setValue(
        "sokoshubetsuKbn",
        getSCode(B100100Sokoshubetsu, sokoshubetsuKbn.hikiateSoko)
      );
      methods.setValue("logicalsokoCd", "");
      methods.setValue("logicalsokoNmr", "");
      methods.setValue("physicalsokoCd", "");
      methods.setValue("physicalsokoNmr", "");
      methods.setValue(
        "locationkanriKbn",
        getSCode(LocationKanriKbn, locationkanriKbn.notManagement)
      );
      methods.setValue("sakujoyoteiKbn", getSCode(SakujoyoteiKbn, "0"));
      methods.setValue("version", "");
    });

  // 倉庫種別関連設定
  await B100100SokoshubetsuKbn(methods, navigate, setMsg);
};

// 倉庫種別関連設定
export const B100100SokoshubetsuKbn = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 倉庫種別に関する項目をクリア
  methods.setValue("logicalsokoCd", "");
  methods.setValue("logicalsokoNmr", "");
  methods.setValue("physicalsokoCd", "");
  methods.setValue("physicalsokoNmr", "");
  methods.setValue("locationkanriKbn", null);

  const data = methods.getValues();

  // 倉庫種別区分：0(物理倉庫)の場合
  if (Number(data.sokoshubetsuKbn?.value) === sokoshubetsuKbn.physicalSoko) {
    // ロケーション管理区分に 1(管理する)を設定
    methods.setValue(
      "locationkanriKbn",
      getSCode(LocationKanriKbn, locationkanriKbn.management)
    );
  }
  // 倉庫種別区分：1(論理倉庫)の場合
  else if (
    Number(data.sokoshubetsuKbn?.value) === sokoshubetsuKbn.logicalSoko
  ) {
    // ロケーション管理区分に 0(管理しない)を設定
    methods.setValue(
      "locationkanriKbn",
      getSCode(LocationKanriKbn, locationkanriKbn.notManagement)
    );
    // 物理倉庫コードに 901 を設定し、名称取得
    methods.setValue("physicalsokoCd", physicalsokoCd);
    await B000190PhysicalsokoNmr(methods, navigate, setMsg);
  }
  // 倉庫種別区分：2(引当倉庫)の場合
  else if (
    Number(data.sokoshubetsuKbn?.value) === sokoshubetsuKbn.hikiateSoko
  ) {
    // ロケーション管理区分に 0(管理しない)を設定
    methods.setValue(
      "locationkanriKbn",
      getSCode(LocationKanriKbn, locationkanriKbn.notManagement)
    );
    // 論理倉庫コードに 001 を設定し、名称取得
    methods.setValue("logicalsokoCd", logicalsokoCd);
    await B000190LogicalsokoNm(methods, navigate, setMsg);
  }
  // 倉庫種別区分が上記以外の場合
  else {
    // ロケーション管理区分に 0(管理しない)を設定
    methods.setValue(
      "locationkanriKbn",
      getSCode(LocationKanriKbn, locationkanriKbn.notManagement)
    );
  }
};
